import React, { Fragment, useEffect, useState } from "react";
import { AppRouter } from "../Navigator/Router";
import PreLoadingView from "../modules/Loading/PreLoadingView";
const App = () => {
  // const [preloading, set_preloading] = useState(true);

  // useEffect(() => {
  //   setTimeout(() => {
  //     // window.jQuery("#preload").hide();
  //     set_preloading(false);
  //   }, 5000);
  // }, []);

  // return <>{preloading ? <PreLoadingView /> : <AppRouter />}</>;
  return (
    <>
      <AppRouter />
    </>
  );
};

export default App;
